import React from 'react';
import { Save } from 'lucide-react';
import { Button, type ButtonProps } from './Button';

export interface SubmitButtonProps extends Omit<ButtonProps, 'label'> {
	submitLabel?: string;
	submittingLabel?: string;
	onSubmit: () => void;
	isSubmitting?: boolean;
	submitDisabled?: boolean;
}

export function SubmitButton({
	submitLabel = 'Submit',
	submittingLabel = 'Submitting',
	Icon,
	submitDisabled = false,
	isSubmitting = false,
	onSubmit,
	...props
}: SubmitButtonProps) {
	return (
		<Button
			isDisabled={submitDisabled}
			Icon={Icon ?? Save}
			onClick={onSubmit}
			label={!isSubmitting ? submitLabel : submittingLabel}
			isPending={isSubmitting}
			{...props}
		/>
	);
}
